import { Controller } from "@hotwired/stimulus"

// Manages background color selection for story slides.
export default class extends Controller {
  static targets = ["input"]

  select(event) {
    const color = event.params.color
    if (!color || !this.hasInputTarget) return

    this.inputTarget.value = color

    // Update button ring states
    this.element.querySelectorAll("button").forEach((btn) => {
      const isSelected = btn.dataset.bgColorPickerColorParam === color
      btn.classList.toggle("border-cta", isSelected)
      btn.classList.toggle("ring-2", isSelected)
      btn.classList.toggle("ring-cta/30", isSelected)
      btn.classList.toggle("border-gray-200", !isSelected)
    })
  }
}
